import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../service";

const initialState: any = {
  listItems: [],

  activeItem: {},
  loading: false,
  activeItemloading: false,
};
export const getIncomeCategoryListItems = createAsyncThunk(
  "incomeCategories/getIncomeCategoryListItems",
  async (_, { rejectWithValue }) => {
    try {
      const response: any =
        await apiServices.systemManager.incomeCategory.getList();
      const { isError, data } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch asset list");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getIncomeCategoryDetailById = createAsyncThunk(
  "incomeCategories/getIncomeCategoryDetailById",
  async (incomeId: string, { getState, rejectWithValue }) => {
    if (!incomeId) return rejectWithValue("Invalid actionId ID");

    // Access the current state
    const state: any = getState();

    const itemList = state.incomeCategories.listItems;

    // Find the valuation detail by ID in the listItems array
    const itemDetail = itemList.find((item: any) => item.id === incomeId);
    if (itemDetail) {
      return itemDetail; // Return the detail if found
    } else {
      return rejectWithValue("item detail not found in state");
    }
  }
);

export const incomeCategoriesSlice = createSlice({
  name: "incomeCategories",
  initialState,
  reducers: {
    setActiveIncomeCategory(state, action: any) {
      state.activeItem = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIncomeCategoryListItems.pending, (state) => {
        state.loading = true;
        state.listItems = [];
      })
      .addCase(getIncomeCategoryListItems.fulfilled, (state, action) => {
        state.loading = false;
        state.listItems = action.payload;
      })
      .addCase(getIncomeCategoryListItems.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching  list:", action.payload);
      })
      .addCase(getIncomeCategoryDetailById.pending, (state) => {
        state.activeItemloading = true;
        state.activeItem = {};
      })
      .addCase(getIncomeCategoryDetailById.fulfilled, (state, action) => {
        state.activeItemloading = false;
        state.activeItem = action.payload;
      })
      .addCase(getIncomeCategoryDetailById.rejected, (state, action) => {
        state.activeItemloading = false;
        console.error("Error fetching  details:", action.payload);
      });
  },
});
export const { setActiveIncomeCategory } = incomeCategoriesSlice.actions;
export default incomeCategoriesSlice.reducer;
